module.exports = __webpack_public_path__ + "static/img/logo.05649fa8.png";